// 申请状态弹窗
export const APPLY_STATUS_MODAL = 'APPLY_STATUS_MODAL'